



















import { CommonField } from '@ssp/inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

import DynamicInfo from './DynamicInfo.vue';

@Component({
  components: {
    DynamicInfo,
  },
})
export default class DynamicInfoComponent extends Vue {
  @Prop({ required: true })
  form_values: Array<CommonField | Record<string, any>>;

  @Prop()
  title?: string;

  constructor() {
    super();
  }

  get form_chunks_common_field() {
    return this.form_values.filter((field) => this.isCommonField(field));
  }

  get form_chunks_object() {
    return this.form_values
      .filter((field) => !this.isCommonField(field))
      .map((elm) => ({ values: Object.values(elm), title: Object.keys(elm)[0] }));
  }

  isCommonField(field: Record<string, any>): boolean {
    return !!(field as CommonField).label;
  }
}
